import React from "react";

const DialogContent = ({ children, className = "" }) => (
  <div className={`mt-2 text-slate-500 text-normal ${className}`}>
    {children}
  </div>
);

export default DialogContent;
